import React, { useState } from 'react';
import '../allcss/FloatingContactPanel.css';
import { FaEnvelope } from 'react-icons/fa';
import callIcon from '../Asets/phone.png';
import mapIcon from '../Asets/maps.png';
import whatsappIcon from '../Asets/whatsapp.png';

const FloatingContactPanel = () => {
  const [open, setOpen] = useState(false);
  const togglePanel = () => setOpen(!open);

  return (
    <div className="custom-floating-panel">
      {open ? (
        <>
          <div className="custom-contact-card">
            <a
              href="https://wa.me/7778851070"
              target="_blank"
              rel="noopener noreferrer"
              className="custom-contact-link"
            >
              <span>Whatsapp</span>
              <div className="custom-icon-badge">
                <img src={whatsappIcon} alt="WhatsApp" />
              </div>
            </a>

            <a
              href="https://www.google.com/maps/place/RED+SCHOOL+HOUSE/@22.3471708,73.2125073,17z/data=!3m1!4b1!4m6!3m5!1s0x395fcfb1d27d5277:0x1a8697660f95522e!8m2!3d22.3471708!4d73.2150822!16s%2Fg%2F11x7yxp6xf?entry=ttu&g_ep=EgoyMDI1MDYxMS4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              className="custom-contact-link"
            >
              <span>Google Map</span>
              <div className="custom-icon-badge">
                <img src={mapIcon} alt="Map" />
              </div>
            </a>

            <a href="/contact" className="custom-contact-link">
              <span>Enquiry / Contact Form</span>
              <div className="custom-icon-badge custom-email-icon">
                <FaEnvelope />
              </div>
            </a>
          </div>

          <button className="custom-close-btn" onClick={togglePanel}>×</button>
        </>
      ) : (
        <button className="custom-toggle-btn" onClick={togglePanel}>
          <img src={callIcon} alt="Call" />
        </button>
      )}
    </div>
  );
};

export default FloatingContactPanel;